/* promise/lib/finally */ function _(require, module, exports) {
    var Promise = require(278) /* ./core.js */;
    module.exports = Promise;
    Promise.prototype['finally'] = function (f) {
        return this.then(function (value) {
            return Promise.resolve(f()).then(function () {
                return value;
            });
        }, function (err) {
            return Promise.resolve(f()).then(function () {
                throw err;
            });
        });
    };
}
